// src/components/ChessCamp.jsx
import React, { useMemo, useRef, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";

import heroLandscape from "../images/chess-camp-hero.png";
import heroPortrait from "../images/chess-camp-hero-portrait.png";

export default function ChessCamp() {
  const [open, setOpen] = useState(false);
  const bookRef = useRef(null);

  // ---- Easter Camp booking links (Bookwhen) | every day shown
  const bookingDays = useMemo(
    () => [
      {
        label: "Monday 30 March • 10:00–14:00",
        url: "https://bookwhen.com/chesshood/e/ev-REPLACE-20260330100000",
      },
      {
        label: "Tuesday 31 March • 10:00–14:00",
        url: "https://bookwhen.com/chesshood/e/ev-REPLACE-20260331100000",
      },
      {
        label: "Wednesday 1 April • 10:00–14:00",
        url: "https://bookwhen.com/chesshood/e/ev-REPLACE-20260401100000",
      },
      {
        label: "Thursday 2 April • 10:00–14:00",
        url: "https://bookwhen.com/chesshood/e/ev-REPLACE-20260402100000",
      },
      {
        label: "Friday 3 April • 10:00–14:00",
        url: "https://bookwhen.com/chesshood/e/ev-s3ngi-20260403100000",
      },
      {
        label: "Monday 6 April • 10:00–14:00",
        url: "https://bookwhen.com/chesshood/e/ev-REPLACE-20260406100000",
      },
      {
        label: "Tuesday 7 April • 10:00–14:00",
        url: "https://bookwhen.com/chesshood/e/ev-REPLACE-20260407100000",
      },
      {
        label: "Wednesday 8 April • 10:00–14:00",
        url: "https://bookwhen.com/chesshood/e/ev-REPLACE-20260408100000",
      },
      {
        label: "Thursday 9 April • 10:00–14:00",
        url: "https://bookwhen.com/chesshood/e/ev-REPLACE-20260409100000",
      },
      {
        label: "Friday 10 April • 10:00–14:00",
        url: "https://bookwhen.com/chesshood/e/ev-REPLACE-20260410100000",
      },
    ],
    [],
  );

  // ---- Venue
  const VENUE =
    "Badger Farm & Oliver’s Battery Residents’ Community Association, Badger Farm Road, Winchester, SO22 4QB, UK";

  // ---- Map embed (Badger Farm)
  const MAP_EMBED_SRC =
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d20066.94372986801!2d-1.3774550256836187!3d51.04629310000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48740d0a0077de65%3A0x7ee7b2c47c429539!2sBadger%20Farm%20Community%20Centre!5e0!3m2!1sen!2suk!4v1755680316469!5m2!1sen!2suk";

  const mapsPlaceUrl =
    "https://www.google.com/maps/search/?api=1&query=" +
    encodeURIComponent(VENUE);

  const mapsDirectionsUrl =
    "https://www.google.com/maps/dir/?api=1&destination=" +
    encodeURIComponent(VENUE);

  const publicEventUrl =
    "https://bookwhen.com/chesshood/e/ev-s3ngi-20260403100000";

  // ---- Actions
  const onMore = () => setOpen((v) => !v);

  const onBookNow = () => {
    if (!open) setOpen(true);
    setTimeout(() => {
      bookRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 60);
  };

  // ---- Base styles
  const page = {
    width: "100%",
    margin: 0,
    background: "#ffffff",
    color: "#111111",
  };

  const wrap = { padding: "2%" };

  const heroBox = {
    width: "96%",
    margin: "0 auto",
    position: "relative",
  };

  const imgBase = {
    width: "100%",
    height: "auto",
    display: "block",
    borderRadius: 16,
  };

  const overlayBar = {
    position: "absolute",
    left: "50%",
    transform: "translateX(-50%)",
    bottom: 12,
    width: "min(520px, calc(100% - 24px))",
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 10,
    pointerEvents: "none",
    padding: 10,
    borderRadius: 18,
    background: "rgba(255,255,255,0.58)",
    backdropFilter: "blur(8px)",
    WebkitBackdropFilter: "blur(8px)",
  };

  const btnBase = {
    appearance: "none",
    width: "100%",
    borderRadius: 14,
    padding: "12px 14px",
    fontWeight: 900,
    cursor: "pointer",
    userSelect: "none",
    pointerEvents: "auto",
    lineHeight: 1,
    border: "1px solid #111111",
    fontSize: "1rem",
  };

  const btnMore = {
    ...btnBase,
    background: "rgba(255,255,255,0.96)",
    color: "#111111",
  };

  const btnBook = {
    ...btnBase,
    background: "#111111",
    color: "#ffffff",
  };

  const section = { padding: "0 2% 2% 2%" };

  const card = {
    background: "#ffffff",
    border: "1px solid #ededed",
    borderRadius: 14,
    padding: 12,
  };

  const h3 = { margin: 0, fontSize: "1.12rem", fontWeight: 950 };
  const p = { margin: "8px 0 0 0", lineHeight: 1.5, color: "#222" };
  const list = { margin: "8px 0 0 16px", color: "#222", lineHeight: 1.55 };

  const pill = {
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    padding: "7px 10px",
    borderRadius: 999,
    border: "1px solid #e9e9e9",
    background: "#fafafa",
    fontWeight: 800,
    color: "#111",
    fontSize: "0.92rem",
    marginTop: 8,
  };

  const bookingBtn = {
    display: "block",
    width: "100%",
    textDecoration: "none",
    textAlign: "center",
    padding: "10px 12px",
    borderRadius: 12,
    border: "1px solid #111111",
    background: "#ffffff",
    color: "#111111",
    fontWeight: 900,
  };

  const mapWrap = {
    position: "relative",
    width: "100%",
    paddingTop: "56.25%",
    borderRadius: 14,
    overflow: "hidden",
    border: "1px solid #ededed",
    background: "#f6f6f6",
  };

  const mapIframe = {
    position: "absolute",
    inset: 0,
    width: "100%",
    height: "100%",
    border: 0,
  };

  const linkBtn = {
    padding: "9px 12px",
    borderRadius: 12,
    border: "1px solid #111111",
    textDecoration: "none",
    color: "#111111",
    display: "inline-block",
    fontWeight: 900,
    background: "#ffffff",
  };

  const darkBtn = {
    ...linkBtn,
    background: "#111111",
    color: "#ffffff",
  };

  const pressDown = (e) => (e.currentTarget.style.transform = "scale(0.98)");
  const pressUp = (e) => (e.currentTarget.style.transform = "scale(1)");

  const localCss = `
    .cc-hero-img { display:block; }

    @media (max-width: 640px) and (orientation: portrait) {
      .cc-hero-img {
        object-fit: contain !important;
        max-height: 92vh !important;
        background: #fff;
      }
      .cc-overlay {
        grid-template-columns: 1fr !important;
        width: calc(100% - 20px) !important;
        bottom: 10px !important;
        padding: 10px !important;
        border-radius: 16px !important;
      }
      .cc-btn {
        font-size: 1rem !important;
        padding: 12px 14px !important;
        border-radius: 14px !important;
      }
    }

    @media (max-width: 900px) and (orientation: landscape) {
      .cc-hero-img {
        object-fit: cover !important;
      }
      .cc-overlay {
        grid-template-columns: 1fr 1fr !important;
        width: min(520px, calc(100% - 20px)) !important;
        bottom: 10px !important;
        padding: 8px !important;
      }
      .cc-btn {
        font-size: 0.95rem !important;
        padding: 10px 12px !important;
      }
    }

    @media (min-width: 901px) {
      .cc-hero-img { object-fit: cover; }
    }
  `;

  return (
    <div style={page}>
      <style>{localCss}</style>

      <Container fluid className="p-0">
        {/* HERO */}
        <div style={wrap}>
          <div style={heroBox}>
            <picture>
              <source media="(orientation: portrait)" srcSet={heroPortrait} />
              <source media="(orientation: landscape)" srcSet={heroLandscape} />
              <img
                className="cc-hero-img"
                src={heroLandscape}
                alt="Easter Chess Camp Winchester"
                style={imgBase}
              />
            </picture>

            <div className="cc-overlay" style={overlayBar}>
              <button
                type="button"
                className="cc-btn"
                style={btnMore}
                onClick={onMore}
                onMouseDown={pressDown}
                onMouseUp={pressUp}
                onMouseLeave={pressUp}
              >
                {open ? "Hide" : "More…"}
              </button>

              <button
                type="button"
                className="cc-btn"
                style={btnBook}
                onClick={onBookNow}
                onMouseDown={pressDown}
                onMouseUp={pressUp}
                onMouseLeave={pressUp}
              >
                Book now
              </button>
            </div>
          </div>
        </div>

        {/* EXPAND */}
        {open && (
          <div style={section}>
            <Row className="g-2">
              <Col xs={12} md={7}>
                <div style={card}>
                  <h3 style={h3}>Easter Chess Camp (Winchester)</h3>
                  <div style={pill}>📅 30 March–10 April • 10:00–14:00</div>

                  <p style={p}>
                    Easter Chess Camp – fun, friendly coaching for all levels.
                    Small groups, puzzles, games and mini-tournaments.
                  </p>

                  <ul style={list}>
                    <li>
                      <strong>Dates:</strong> all camp days listed separately in
                      booking buttons.
                    </li>
                    <li>
                      <strong>Ticket:</strong> Easter Chess Camp • £35.00
                    </li>
                    <li>
                      <strong>Leaders:</strong> chesshampshire@gmail.com
                    </li>
                    <li>
                      <strong>Discount:</strong> book 5 days in one week and get
                      20% off automatically (£28/day, £140/week instead of
                      £175).
                    </li>
                  </ul>
                </div>
              </Col>

              <Col xs={12} md={5}>
                <div style={card} ref={bookRef}>
                  <h3 style={h3}>Book your place</h3>
                  <p style={{ ...p, marginTop: 8 }}>
                    Choose single days (£35) or full week with automatic 20%
                    discount.
                  </p>

                  <Row className="g-2" style={{ marginTop: 6 }}>
                    {bookingDays.map((d) => (
                      <Col xs={12} key={d.url}>
                        <a
                          href={d.url}
                          target="_blank"
                          rel="noreferrer"
                          style={bookingBtn}
                        >
                          {d.label}
                        </a>
                      </Col>
                    ))}
                  </Row>

                  <div
                    style={{
                      display: "flex",
                      gap: 10,
                      flexWrap: "wrap",
                      marginTop: 10,
                    }}
                  >
                    <a
                      href={publicEventUrl}
                      target="_blank"
                      rel="noreferrer"
                      style={darkBtn}
                    >
                      Open event page
                    </a>
                  </div>
                </div>
              </Col>

              <Col xs={12}>
                <div style={card}>
                  <h3 style={h3}>Instructions</h3>
                  <ul style={list}>
                    <li>Please arrive 5–10 minutes early.</li>
                    <li>Bring a water bottle and a small snack.</li>
                    <li>All chess equipment is provided.</li>
                  </ul>
                </div>
              </Col>

              <Col xs={12}>
                <div style={card}>
                  <h3 style={h3}>Where to find us</h3>

                  <Row className="g-2" style={{ marginTop: 6 }}>
                    <Col xs={12} md={5}>
                      <p style={{ ...p, marginTop: 0, fontWeight: 900 }}>
                        Badger Farm & Oliver’s Battery Residents’ Community
                        Association
                      </p>
                      <p style={{ ...p, marginTop: 6 }}>
                        Badger Farm Road, Winchester, SO22 4QB
                      </p>

                      <div
                        style={{
                          display: "flex",
                          gap: 10,
                          flexWrap: "wrap",
                          marginTop: 10,
                        }}
                      >
                        <a
                          href={mapsPlaceUrl}
                          target="_blank"
                          rel="noreferrer"
                          style={linkBtn}
                        >
                          View map
                        </a>
                        <a
                          href={mapsDirectionsUrl}
                          target="_blank"
                          rel="noreferrer"
                          style={linkBtn}
                        >
                          Directions
                        </a>
                      </div>
                    </Col>

                    <Col xs={12} md={7}>
                      <div style={mapWrap}>
                        <iframe
                          title="Map: Badger Farm Community Centre"
                          src={MAP_EMBED_SRC}
                          style={mapIframe}
                          loading="lazy"
                          allowFullScreen
                          referrerPolicy="no-referrer-when-downgrade"
                        />
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </div>
        )}
      </Container>
    </div>
  );
}
